/**
 * Выполняет асинхронный запрос с указанной конфигурацией
 * @param cfg{Object} - конфигурация
 * @return Promise
 */

export async function makeRequest (cfg) {
  const {
    method = 'GET',
    mode = 'cors',
    controller = null,
    data = null,
    type = 'json',
    url = window.location.href,
    headers = {
      'X-Requested-With': 'XMLHttpRequest'
    }
  } = cfg
  const resp = await fetch(url, {
    method,
    mode,
    controller,
    headers,
    body: (typeof method === 'string' && method.toUpperCase() === 'POST') ? data : null
  })
  return (resp.ok) ? await (type === 'json') ? resp.json() : resp.text() : Promise.reject(resp.statusText)
}
